import React, { useState, useEffect } from "react";
import { Row, Col, Avatar } from "antd";
import { AudioOutlined } from "@ant-design/icons";
import MainHeader from "../../../../common/MainHeader";
import "./Styles.css";

export default function ComfortingMessage(props) {
  const [audioUrl, setAudioUrl] = useState(null);

  useEffect(() => {
    const { comfortingMessage } = props;
    if (comfortingMessage) {
      setAudioUrl(comfortingMessage);
    }
  }, [props]);

  return (
    <Col span={24} className="comforting-card">
      <Row gutter={[16, 16]}>
        <Col style={{ marginTop: "-20px", marginLeft: "-20px" }}>
          <Avatar
            shape="square"
            size={84}
            icon={<AudioOutlined />}
            className="card-music"
          />
        </Col>
        <Col>
          <div style={{ marginTop: "20px" }}>
            <MainHeader title="Comforting Message" />
          </div>
        </Col>
      </Row>
      <div class="audio-player">
        <audio controls src={audioUrl} type="audio/mpeg"></audio>
      </div>
    </Col>
  );
}
